var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { id: "inspire" } },
    [
      _c(
        "v-app-bar",
        { attrs: { "clipped-left": "", flat: "", app: "" } },
        [
          _c("v-img", {
            staticClass: "ml-5 mr-5",
            attrs: {
              src: "/Sieloggaröd för brevpaper.gif",
              "max-height": "50",
              "max-width": "90",
              contain: "",
            },
          }),
          _vm._v(" "),
          _c("v-toolbar-title", { staticClass: "hidden-sm-and-down mr-10" }, [
            _c("strong", [_vm._v("SIE Testbänk")]),
          ]),
          _vm._v(" "),
          _c(
            "v-toolbar-items",
            { staticClass: "hidden-sm-and-down" },
            [_c("v-spacer")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-main", [_c("home")], 1),
      _vm._v(" "),
      _c("v-footer", { attrs: { app: "" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }